export default {
    change_puls_customer_title: "Cambiar la Cuenta Calamp",
    change_puls_customer_label: "Cuenta Calamp",
    change_puls_customer_account_label: "Cuenta Calamp",
    change_puls_customer_input: "IMEI o serie",
    change_puls_customer_imei: "IMEI",
    change_puls_customer_serial: "Serie",
    change_puls_customer_model: "Modelo",
    change_puls_customer_change: "Cambiar",
    change_puls_customer_no_devices_added: "No se han añadido dispositivos",
    change_puls_customer_device_is_already_added: "El dispositivo ya está añadido",
    change_puls_customer_device_has_not_been_found: "No se ha encontrado el dispositivo",
    change_puls_customer_this_feature_is_not_available: "Esta función no está disponible",
    change_puls_customer_single_success_message: "La cuenta calamp del dispositivo ha sido cambiada",
    change_puls_customer_multiple_success_message: "Se ha actualizado la cuenta calamp de los dispositivos",
    change_puls_customer_error_message: "No se puede cambiar la cuenta calamp debido a un error",
    change_puls_customer_status: "Estado",
    change_puls_customer_message: "Mensaje",
}